// TODO: Update when other domains are determined.
export default {
  DAILY: {
    prefix: 'acs',
    subDomain: 'waptest',
    mainDomain: 'lazada.test'
  },
  PRE: {
    ES: {
      prefix: '',
      subDomain: 'pre-acs-m',
      mainDomain: ~location.host.indexOf('proyectoarise.es') ? 'proyectoarise.es' : 'miravia.es' // 过度期，先兼容 proyectoarise.es, 往后废弃
    },

    FR: {
      prefix: 'acs',
      subDomain: 'dev-arise',
      mainDomain: 'lazada.com'
    }
  },
  PROD: {
    ES: {
      prefix: '',
      subDomain: 'acs-m',
      mainDomain: ~location.host.indexOf('proyectoarise.es') ? 'proyectoarise.es' : 'miravia.es' // 过度期，先兼容 proyectoarise.es, 往后废弃
    },

    FR: {
      prefix: 'acs',
      subDomain: 'dev-arise',
      mainDomain: 'lazada.com'
    }
  }
};